import AuthService from '@/services/auth';
import AnalyticsTracking from '@/analytics/tracking';

const clearToken = ({ commit }) => {
  commit('setUserToken', '');
  AuthService.removeLocalUser();
  AnalyticsTracking.resetUser();
};

export default {
  clearToken
};



// WEBPACK FOOTER //
// ./src/store/modules/user/actions.js